<template>
  <div class="student-login-panel"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="loginInfo">
      <AppScrollbar style="height: 100%">
        <div class="info-wrap">
          <TitleGroup fold>
            <template #title>
              <i class="el-icon-lock"></i>
              <span class="title">账号详情</span>
            </template>
            <div class="login-wrap">
              <el-form size="mini"
                       label-width="110px"
                       label-suffix="：">
                <el-form-item label="登录账号">{{loginInfo.loginId}}</el-form-item>
                <el-form-item label="证件号码">{{loginInfo.idCard}}</el-form-item>
                <el-form-item label="重置密码">
                  <el-button size="mini"
                             type="text"
                             :loading="committing"
                             @click="handleResetPwd">
                    <span v-if="committing">重置中...</span>
                    <span v-else>重置密码</span>
                  </el-button>
                </el-form-item>
                <el-form-item></el-form-item>
              </el-form>
              <div class="login-record">
                <div class="label">最近10次登录记录：</div>
                <div class="value">
                  <DataGrid size="mini"
                            border="inner"
                            :data="loginInfo.loginRecords">
                    <DataGridColumn title="登录时间"
                                    field="loginDate"
                                    align="center"></DataGridColumn>
                    <DataGridColumn title="登录地点"
                                    field="ipRegion"
                                    align="center"></DataGridColumn>
                    <DataGridColumn title="登录IP"
                                    field="ip"
                                    align="center"></DataGridColumn>
                    <DataGridColumn title="登录平台"
                                    field="platform"
                                    align="center"></DataGridColumn>
                    <template #empty>
                      <span>暂无账号登录记录</span>
                    </template>
                  </DataGrid>
                </div>
              </div>
            </div>
          </TitleGroup>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading">
        <span>请求数据加载失败</span>
        <el-button type="text"
                   @click="loadLoginInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'StudentLoginPanel',
  components: {
    AppScrollbar,
    TitleGroup,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      loginInfo: null,
      committing: false
    }
  },
  methods: {
    loadLoginInfo () {
      this.$emit('start-refresh')
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/student/info/login',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.loginInfo = response.data['loginInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        this.$emit('end-refresh')
      })
    },
    handleResetPwd () {
      this.$confirm('确定要重置学生的密码吗？重置后密码为身份证后六位！', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/portal/student/resetPwd',
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.studentId
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    // 这里不再加载，因为已经通过最外层组件用watch刷新了
    // this.loadLoginInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadLoginInfo()
      }
    }
  }
}
</script>

<style lang="scss">
  .student-login-panel {
    height: 100%;
    background-color: #fff;
    .info-wrap {
      padding: 15px;
      .login-wrap {
        .el-form {
          padding-left: 12px;
          .el-form-item {
            margin-bottom: 5px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-form-item__label {
              color: #909399;
              font-size: 12px;
              text-align: left;
            }
            .el-form-item__content {
              color: #303133;
              font-size: 12px;
            }
          }
        }
        .login-record {
          margin-top: 5px;
          & > .label {
            color: #909399;
            font-size: 12px;
            padding-left: 12px;
          }
          & > .value {
            margin-top: 15px;
            .vxe-table {
              .vxe-table--header-wrapper {
                .vxe-table--header {
                  .vxe-header--row {
                    background-color: #f3f4f5;
                    .vxe-header--column {
                      height: 46px;
                    }
                  }
                }
              }
              .vxe-table--body-wrapper {
                .vxe-table--body {
                  .vxe-body--row {
                    .vxe-body--column {
                      height: 46px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
